import { useRef, useState } from "react"
import { useNavigate, useSearchParams } from "react-router-dom"
import { Principles } from "../OurServices/Principles"
import { ScrollTo } from "react-scroll-to";


export const HerosectionsAll = (props) => {
    const { ScreenName, ScreenSearch } = props
    const navigate = useNavigate()
    const [searchparams] = useSearchParams()
    // const ScreenName = searchparams.get('ScreenName')
    const Name = searchparams.get('Name')
    const SubName = searchparams.get('SubName')
    const SubsecondName = searchparams.get('SubsecondName')

    const [BtnShow, setBtnShow] = useState(1);
    console.log("SubName", SubName);

    return (
        <>
            <div className="container-fluid">
                <div className="row shadow2" >
                    <div className={`col-12 ${ScreenSearch} d-flex`}>

                        <div className="col-12 col-lg-5 d-flex justify-content-center align-items-center pt-5">
                            <div className="row">
                                <div className="col-12 pt-5">
                                    <h2 className=" text-center green display-6 fw-bold" style={{ textTransform: 'uppercase', letterSpacing: '2px' }}>
                                        <b>{ScreenName}</b>
                                    </h2>
                                </div>
                                <div className="col-12 d-flex justify-content-center align-items-center">
                                    <nav aria-label="breadcrumb " className="">
                                        <ol className="breadcrumb indigo lighten-6 first-1  pt-4 text-center ">
                                            <li>
                                                <a className=" ms-1 green fw-bold fs-6" href="javascript:void(0) "
                                                    onClick={() => navigate('/')} ><span>Home</span></a>
                                                <i className="fas fa-angle-double-right green px-3"></i> </li>
                                            {
                                                Name &&
                                                <li><a className="green fw-bold fs-6"
                                                    href="javascript:void(0)"><span>{Name}</span></a> <i
                                                        className="fas fa-angle-double-right silver px-3"></i></li>
                                            }

                                            {
                                                SubName &&
                                                <li><a className="green fw-bold fs-6"
                                                    href="javascript:void(0)"

                                                    onClick={() => {
                                                        SubName == "Consultancy" ?
                                                            navigate('/Consultancy?ScreenName=Consultancy&Name=Services')
                                                            :
                                                            navigate('/LearningAndDevelopment?ScreenName=LearningAndDevelopment&Name=Services')
                                                    }}>
                                                    <span>{SubName}</span></a> <i className="fas fa-angle-double-right silver px-3"></i></li>
                                            }
                                            {/* {
                                            SubsecondName &&
                                            <li><a className="green fw-bold fs-6"
                                                href="javascript:void(0)"
                                                onClick={() => navigate('/Services?ScreenName=Principles of Insurance&Name=Services')}><span>{SubsecondName}</span></a> <i
                                                    className="fas fa-angle-double-right silver px-3"></i></li>
                                        } */}

                                            <li className="breadcrumb-item font-weight-bold "><a className=" fw-bold fs-6"
                                                href="javascript:void(0)" style={{ textTransform: 'capitalize' }}><span>{ScreenName}</span></a></li>
                                        </ol>
                                    </nav>
                                </div>
                            </div>
                        </div>

                        {/* {
                        ScreenName == "Principles of Insurance" && <div className="col-6 pt-2 d-none d-lg-block">

                            <ScrollTo>
                                {({ scroll }) => (
                                    <p className='Relative_Position mb-0 cursor_pointer' id="princes" onClick={() => setBtnShow(1)}>
                                        <img src="Static/Assets/Img/Banner/1-03.png" alt="" srcset="" className="banner1 " />
                                        <span className="Absolute_Position ps-2" onClick={(() => scroll({ y: 200 }))}>1) CONTRACT OF INSURANCE</span></p>
                                )}
                            </ScrollTo>

                            <ScrollTo>
                                {({ scroll }) => (
                                    <p className='Relative_Position mb-0 cursor_pointer' id="princes" onClick={() => setBtnShow(2)} style={{ left: '23vw' }} >
                                        <img src="Static/Assets/Img/Banner/1-03.png" alt="" srcset="" className="banner1 cursor_pointer" />
                                        <span className="Absolute_Position ps-3" onClick={(() => scroll({ y: 200 }))}>2) UTMOST GOOD FAITH</span></p>
                                )}
                            </ScrollTo>

                            <ScrollTo>
                                {({ scroll }) => (
                                    <p className='Relative_Position cursor_pointer ms-5 mb-0 mt-1' id="princes" onClick={() => setBtnShow(3)}>
                                        <img src="Static/Assets/Img/Banner/1-03.png" alt="" srcset="" className="banner1 " />
                                        <span className="Absolute_Position ps-5" onClick={(() => scroll({ y: 200 }))}>3) INDEMNITY</span></p>
                                )}
                            </ScrollTo>

                            <ScrollTo>
                                {({ scroll }) => (
                                    <p className='Relative_Position mb-0 cursor_pointer' id="princes" onClick={() => setBtnShow(4)} style={{ left: '27vw' }}>
                                        <img src="Static/Assets/Img/Banner/1-03.png" alt="" srcset="" className="banner1 cursor_pointer" />
                                        <span className="Absolute_Position ps-4" onClick={(() => scroll({ y: 200 }))}>4) INSURABLE INTEREST</span></p>
                                )}
                            </ScrollTo>

                            <ScrollTo>
                                {({ scroll }) => (
                                    <p className='Relative_Position cursor_pointer mb-0 mt-1' id="princes" style={{ marginLeft: '90px' }} onClick={() => setBtnShow(5)}>
                                        <img src="Static/Assets/Img/Banner/1-03.png" alt="" srcset="" className="banner1 " />
                                        <span className="Absolute_Position ps-5" onClick={(() => scroll({ y: 200 }))}>5) CONTRIBUTION</span></p>
                                )}
                            </ScrollTo>

                            <ScrollTo>
                                {({ scroll }) => (
                                    <p className='Relative_Position  cursor_pointer mb-0' id="princes" onClick={() => setBtnShow(6)} style={{ left: '29vw' }}>
                                        <img src="Static/Assets/Img/Banner/1-03.png" alt="" srcset="" className="banner1 cursor_pointer" />
                                        <span className="Absolute_Position ps-5" onClick={(() => scroll({ y: 200 }))}>6) SUBROGATION</span></p>
                                )}
                            </ScrollTo>

                            <ScrollTo>
                                {({ scroll }) => (
                                    <p className='Relative_Position cursor_pointer mb-0 mt-1' id="princes" style={{ marginLeft: '150px' }} onClick={() => setBtnShow(7)}>
                                        <img src="Static/Assets/Img/Banner/1-03.png" alt="" srcset="" className="banner1 " />
                                        <span className="Absolute_Position ps-3" onClick={(() => scroll({ y: 200 }))}>7) RETURN OF PREMIUM</span></p>
                                )}
                            </ScrollTo>

                        </div>
                    } */}


                        {/* {
                        ScreenName == "Principles of Insurance" && <div className="col-6 pt-2 d-none d-lg-block">

                            <ScrollTo>
                                {({ scroll }) => (
                                    <p className='Relative_Position mb-0 cursor_pointer' id="princes" onClick={() => setBtnShow(1)}>
                                        <img src="Static/Assets/Img/Banner/1-03.png" alt="" srcset="" className="banner1 " />
                                        <span className="Absolute_Position ps-2" onClick={(() => scroll({ y: 200 }))}>1) CONTRACT OF INSURANCE</span></p>
                                )}
                            </ScrollTo>

                            <ScrollTo>
                                {({ scroll }) => (
                                    <p className='Relative_Position mb-0 cursor_pointer' id="princes" onClick={() => setBtnShow(2)} style={{ left: '23vw' }} >
                                        <img src="Static/Assets/Img/Banner/1-03.png" alt="" srcset="" className="banner1 cursor_pointer" />
                                        <span className="Absolute_Position ps-3" onClick={(() => scroll({ y: 200 }))}>2) UTMOST GOOD FAITH</span></p>
                                )}
                            </ScrollTo>

                            <ScrollTo>
                                {({ scroll }) => (
                                    <p className='Relative_Position cursor_pointer ms-5 mb-0 mt-1' id="princes" onClick={() => setBtnShow(3)}>
                                        <img src="Static/Assets/Img/Banner/1-03.png" alt="" srcset="" className="banner1 " />
                                        <span className="Absolute_Position ps-5" onClick={(() => scroll({ y: 200 }))}>3) INDEMNITY</span></p>
                                )}
                            </ScrollTo>

                            <ScrollTo>
                                {({ scroll }) => (
                                    <p className='Relative_Position mb-0 cursor_pointer' id="princes" onClick={() => setBtnShow(4)} style={{ left: '27vw' }}>
                                        <img src="Static/Assets/Img/Banner/1-03.png" alt="" srcset="" className="banner1 cursor_pointer" />
                                        <span className="Absolute_Position ps-4" onClick={(() => scroll({ y: 200 }))}>4) INSURABLE INTEREST</span></p>
                                )}
                            </ScrollTo>

                            <ScrollTo>
                                {({ scroll }) => (
                                    <p className='Relative_Position cursor_pointer mb-0 mt-1' id="princes" style={{ marginLeft: '90px' }} onClick={() => setBtnShow(5)}>
                                        <img src="Static/Assets/Img/Banner/1-03.png" alt="" srcset="" className="banner1 " />
                                        <span className="Absolute_Position ps-5" onClick={(() => scroll({ y: 200 }))}>5) CONTRIBUTION</span></p>
                                )}
                            </ScrollTo>

                            <ScrollTo>
                                {({ scroll }) => (
                                    <p className='Relative_Position  cursor_pointer mb-0' id="princes" onClick={() => setBtnShow(6)} style={{ left: '29vw' }}>
                                        <img src="Static/Assets/Img/Banner/1-03.png" alt="" srcset="" className="banner1 cursor_pointer" />
                                        <span className="Absolute_Position ps-5" onClick={(() => scroll({ y: 200 }))}>6) SUBROGATION</span></p>
                                )}
                            </ScrollTo>

                            <ScrollTo>
                                {({ scroll }) => (
                                    <p className='Relative_Position cursor_pointer mb-0 mt-1' id="princes" style={{ marginLeft: '150px' }} onClick={() => setBtnShow(7)}>
                                        <img src="Static/Assets/Img/Banner/1-03.png" alt="" srcset="" className="banner1 " />
                                        <span className="Absolute_Position ps-3" onClick={(() => scroll({ y: 200 }))}>7) RETURN OF PREMIUM</span></p>
                                )}
                            </ScrollTo>

                        </div>
                    } */}


                    </div>


                    {/* {
                    ScreenName == "Principles of Insurance" && <div className="col-12 pt-3 d-block d-lg-none ps-4">

                        <ScrollTo>
                            {({ scroll }) => (
                                <p className='Relative_Position mb-2 cursor_pointer' id="princes" onClick={() => setBtnShow(1)}>
                                    <img src="Static/Assets/Img/Banner/1-03.png" alt="" srcset="" className="banner1 " />
                                    <span className="Absolute_Position" onClick={(() => scroll({ y: 200 }))}>CONTRACT OF INSURANCE</span></p>
                            )}
                        </ScrollTo>

                        <ScrollTo>
                            {({ scroll }) => (
                                <p className='Relative_Position mb-2 cursor_pointer' id="princes" onClick={() => setBtnShow(2)}  >
                                    <img src="Static/Assets/Img/Banner/2-02.png" alt="" srcset="" className="banner1 cursor_pointer" />
                                    <span className="Absolute_Position ps-2" onClick={(() => scroll({ y: 200 }))}>UTMOST GOOD FAITH</span></p>
                            )}
                        </ScrollTo>

                        <ScrollTo>
                            {({ scroll }) => (
                                <p className='Relative_Position cursor_pointer mb-2' id="princes" onClick={() => setBtnShow(3)}>
                                    <img src="Static/Assets/Img/Banner/3-02.png" alt="" srcset="" className="banner1 " />
                                    <span className="Absolute_Position ps-5" onClick={(() => scroll({ y: 200 }))}>INDEMNITY</span></p>
                            )}
                        </ScrollTo>

                        <ScrollTo>
                            {({ scroll }) => (
                                <p className='Relative_Position mb-2 cursor_pointer' id="princes" onClick={() => setBtnShow(4)} >
                                    <img src="Static/Assets/Img/Banner/4-02.png " alt="" srcset="" className="banner1 cursor_pointer" />
                                    <span className="Absolute_Position ps-3" onClick={(() => scroll({ y: 200 }))}>INSURABLE INTEREST</span></p>
                            )}
                        </ScrollTo>

                        <ScrollTo>
                            {({ scroll }) => (
                                <p className='Relative_Position cursor_pointer mb-2' id="princes" onClick={() => setBtnShow(5)}>
                                    <img src="Static/Assets/Img/Banner/5-02.png" alt="" srcset="" className="banner1 " />
                                    <span className="Absolute_Position ps-4" onClick={(() => scroll({ y: 200 }))}>CONTRIBUTION</span></p>
                            )}
                        </ScrollTo>

                        <ScrollTo>
                            {({ scroll }) => (
                                <p className='Relative_Position  cursor_pointer mb-2' id="princes" onClick={() => setBtnShow(6)} >
                                    <img src="Static/Assets/Img/Banner/6-02.png" alt="" srcset="" className="banner1 cursor_pointer" />
                                    <span className="Absolute_Position ps-4" onClick={(() => scroll({ y: 200 }))}>SUBROGATION</span></p>
                            )}
                        </ScrollTo>

                        <ScrollTo>
                            {({ scroll }) => (
                                <p className='Relative_Position cursor_pointer mb-4' id="princes" onClick={() => setBtnShow(7)}>
                                    <img src="Static/Assets/Img/Banner/7-02.png" alt="" srcset="" className="banner1 " />
                                    <span className="Absolute_Position ps-2" onClick={(() => scroll({ y: 200 }))}>RETURN OF PREMIUM</span></p>
                            )}
                        </ScrollTo>

                    </div>
                } */}
                </div>
            </div>
            {/* {
                ScreenName == "Principles of Insurance" &&
                <Principles
                    BtnShow={BtnShow}
                />
            } */}


        </>
    )
}
